
import Tab from 'vux/src/components/tab/tab.vue'
import TabItem from 'vux/src/components/tab/tab-item.vue'
import Swiper from 'vux/src/components/swiper/swiper.vue'
import SwiperItem from 'vux/src/components/swiper/swiper-item.vue'
import Group from 'vux/src/components/group/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import Loading from 'vux/src/components/loading/index.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'


export default {
  directives: {
    TransferDom
  },
  components: {
    Tab,
    TabItem,
    Swiper,
    SwiperItem,
    Group,
    Cell,
    Loading
  },
  data () {
    return {
      wday: this.$store.state.weekDay,
      activeLabel: this.weekLabels && this.weekLabels[this.wday]
    }
  },
  computed: {
    keyedCourses () {
      return this.$store.getters.keyedCourses
    },
    schedules () {
      return this.$store.state.weekSchedules['week']
    },
    weekLabels () {
      const weekLabels = ['星期一', '星期二', '星期三', '星期四', '星期五']
      if (this.$store.state.weekSchedules['days_in_week'] > 5) {
        weekLabels.push('星期六')
      }
      if (this.$store.state.weekSchedules['days_in_week'] > 6) {
        weekLabels.push('星期日')
      }
      return weekLabels
    }
  },
  created () {
    this.$store.dispatch('load', ['allCourses', 'weekSchedules'])
      .then(() => { this.$vux.loading.hide() })
  },
  async mounted () {
    this.$vux.loading.show()
  }
}



// WEBPACK FOOTER //
// ./src/components/Schedule.vue